export default {
  enabledRules: [],
  disabledRules: [],
  cooldown: null,
  cooldownTypeId: null,
  dontSentIfCustomerHasAlreadyPurchasedRecomendatedProduct: null,
  dontSentIfCustomerHasAlreadyPurchasedRecomendatedProductTypeId: null,
  numberOfRulesSentAfterAction: null,
  numberOfRulesSentAfterActionId: null,
  deletedPagesCount: 0,
  trackerProductCategories: [],
  isLoading: false,
  hasError: false,
};
